'use client';

import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderCardGrid } from './provider-card-grid';

export const OutsideSearchAreaSeparator = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <ProviderCardGrid role={'separator'}>
      <div
        className={
          'col-span-2 mb-6 flex items-center gap-3 tablet:mb-[32px] desktop:col-start-2 desktop:mb-[16px]'
        }
      >
        <div className={'h-px flex-1 bg-gray-200'} />
        <span className={'shrink-0 text-body-small-semibold text-gray-500'}>
          {t('search.outsideSearchArea')}
        </span>
        <div className={'h-px flex-1 bg-gray-200'} />
      </div>
    </ProviderCardGrid>
  );
};
